var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoreBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 952,
    height: 501,
    viewBox: "0 0 952 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_6165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 953,
    height: 547
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 952.37,
    height: 547,
    fill: "#F0EAE3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_6165)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 0.707107 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2694,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 87.2694 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.831,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 173.831 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.393,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 260.393 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.955,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 346.955 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.517,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 433.517 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.961,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 519.961 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.523,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 606.523 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.085,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 693.085 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.647,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 779.647 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866.209,
    y: 43.281,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 866.209 43.281)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 0.707107 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2694,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 87.2694 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.831,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 173.831 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.393,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 260.393 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.955,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 346.955 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.517,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 433.517 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.961,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 519.961 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.523,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 606.523 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.085,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 693.085 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.647,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 779.647 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866.209,
    y: 129.993,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 866.209 129.993)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 0.707107 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2694,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 87.2694 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.831,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 173.831 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.393,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 260.393 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.955,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 346.955 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.517,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 433.517 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.961,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 519.961 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.523,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 606.523 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.085,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 693.085 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.647,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 779.647 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866.209,
    y: 216.706,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 866.209 216.706)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 0.707107 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2694,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 87.2694 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.831,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 173.831 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.393,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 260.393 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.955,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 346.955 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.517,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 433.517 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.961,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 519.961 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.523,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 606.523 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.085,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 693.085 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.647,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 779.647 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866.209,
    y: 303.418,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 866.209 303.418)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 0.707107 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2694,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 87.2694 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.831,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 173.831 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.393,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 260.393 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.955,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 346.955 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.517,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 433.517 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.961,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 519.961 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.523,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 606.523 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.085,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 693.085 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.647,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 779.647 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866.209,
    y: 390.13,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 866.209 390.13)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 0.707107 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2694,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 87.2694 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.831,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 173.831 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.393,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 260.393 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.955,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 346.955 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.517,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 433.517 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.961,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 519.961 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.523,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 606.523 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.085,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 693.085 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.647,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 779.647 476.842)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866.209,
    y: 476.842,
    width: 60.2087,
    height: 60.2087,
    transform: "rotate(-45 866.209 476.842)",
    stroke: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreBg);
export default __webpack_public_path__ + "static/media/scoreBg.daf612559611947b07d87e516a4b93d0.svg";
export { ForwardRef as ReactComponent };